import { render, staticRenderFns } from "./PropertyAddressForm.vue?vue&type=template&id=7c28f284&scoped=true&"
import script from "./PropertyAddressForm.vue?vue&type=script&lang=js&"
export * from "./PropertyAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28f284",
  null
  
)

export default component.exports